module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 col-sm-6 text-right hidden-xs"
  }, [_c('div', {
    staticClass: "txt-color-white inline-block"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d399be2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LastActivity.vue
// module id = 1055
// module chunks = 1